import React, {useState}from "react";
import { HomeViewWrapper,HomeCardRow, HomeCardCol, HomeCard, HomeCardImgDiv, SkillArrowSection } from './home-view-style';
import { skillCardIcon, trainingCardIcon, ir40strategyIcon,homeResourceIcon, availableTrainingIcon, skillArrow,uniTarBannerWrapperSvg, uniPlayIconSvg, uniCirSvg, unitarInfoSvg, unitarCheckSvg, unitarArrow, unitarExploreCloseSvg, minBtnSvg } from './svg'
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
export const HomeView = (props) => {
    return (
        <HomeViewWrapper data-component="HomeViewWrapper">
            <BreadcrumbsItem to="/">Home</BreadcrumbsItem>
            <HomeCardRow data-component='HomeCardRow'>
                <HomeCardCol data-component="HomeCardCol">
                    <HomeCard data-component="HomeCard" isBorder={true}>
                        <HomeCardImgDiv data-component="HomeCardImgDiv">
                            <i dangerouslySetInnerHTML={{ __html: skillCardIcon }}></i>
                            <span className="status">Todo</span>
                        </HomeCardImgDiv>
                        <p>Skills Assessment</p>
                    </HomeCard>
                    <SkillArrowSection data-component="SkillArrowSection">
                        <i dangerouslySetInnerHTML={{ __html: skillArrow }}></i>
                        <div>
                            <h2>
                              PARTICIPATE IN THE 1st INDUSTRY 4.0 SKILLS STUDY
                            </h2>
                            <p>
                               <span className="num-span">1.</span> <span className="num-text">Take the Assessment</span>
                            </p>
                            <p>
                               <span className="num-span">2.</span> <span className="num-text">Invite your colleagues</span>
                            </p>
                            <p>
                               <span className="num-span">3.</span> <span className="num-text">See how your IR4.0 Skillset Benchmarks</span>
                            </p>
                        </div>
                    </SkillArrowSection>
                </HomeCardCol>
                <HomeCardCol data-component="HomeCardCol">
                    <HomeCard data-component="HomeCard">
                        <HomeCardImgDiv data-component="HomeCardImgDiv">
                            <i dangerouslySetInnerHTML={{ __html: homeResourceIcon }}></i>
                        </HomeCardImgDiv>
                        <p>Resource Center</p>
                    </HomeCard>
                </HomeCardCol>
                <HomeCardCol data-component="HomeCardCol">
                    <HomeCard data-component="HomeCard">
                        <HomeCardImgDiv data-component="HomeCardImgDiv">
                            <i dangerouslySetInnerHTML={{ __html: availableTrainingIcon }}></i>
                            <span className="status blue">Upgrade</span>
                        </HomeCardImgDiv>
                        <p>Available training courses</p>
                    </HomeCard>
                </HomeCardCol>
            </HomeCardRow>
            <UnitarResourcePopup/>
        </HomeViewWrapper>
    )
}

// Unitar Resource Popup
const UnitarResourcePopup = (props) => {
  const [unitarVideoPopup, setUnitarVideoPopup] = useState(false);
  const plyrRef = React.useRef();
  const [isShareAutoPlay, setIsShareAutoPlay] = useState(true);
  const [isActive, setIsActive] = useState(false);
  // Function to toggle the active state
  const handleMinIcon = () => {
    setIsActive(!isActive);
  };


  return (
    <>
      <div className="unitar-resource-main-wrapper">
        <div className={`unitar-resource-pop-wrapper ${isActive ? 'active-min-class' : ''}`}>
          <div className="unitar-resource-pop-card">
            <div className="unitar-resource-pop-header">
              <div className="unitar-pop-head-left">
                <div className="uni-cir-img">
                  <i dangerouslySetInnerHTML={{ __html: uniCirSvg }}></i>
                </div>
                <div className="unitar-text">
                  <span className="bold-text">Mark Johnson</span>
                  <span className="sub-text">General Secretary, UN</span>
                </div>
              </div>
              <button className="unitar-min-btn" onClick={() => handleMinIcon()}>
                <i dangerouslySetInnerHTML={{ __html: minBtnSvg }}></i>
              </button>
            </div>
            <div className="unitar-resource-pop-body">
              <div className="image-container">
                <i className="banner-img" dangerouslySetInnerHTML={{ __html: uniTarBannerWrapperSvg }}></i>
                <button className="uni-play-btn" onClick={() => setUnitarVideoPopup(true)}>
                  <i dangerouslySetInnerHTML={{ __html: uniPlayIconSvg }}></i>
                </button>
              </div>
              <p>
                “Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.
                Velit officia consequat duis enim velit mollit.
                Exercitation veniam consequat sunt nostrud amet est sit aliqua dolor do amet sint.
                Velit officia”.
              </p>
            </div>
            <div className="unitar-resource-pop-footer">
              <a to="#" className="unitar-view-link">View UNITAR Resources</a>
            </div>
          </div>
        </div>
        <button className={`unitar-max-btn ${isActive ? 'active-max-class' : ''}`} onClick={() => handleMinIcon()}>
          Message from <b>General Secretary UN</b>
        </button>
      </div>
      {/* Unitar Resource Video Popup */}

     
    </>
  )
}

